import React from 'react'

const index = () => {
  return (
    <div>
      <h1>ini halaman bihun</h1>
    </div>
  )
}

export default index
